<template>
  <section class="gallery-section">
    <div class="section-container">
      <div class="section-header">
        <span class="section-label">Notre équipe</span>
        <h2 class="section-title">Une équipe passionnée à votre service</h2>
        <p class="section-subtitle">
          Des professionnels dévoués qui s'engagent chaque jour pour votre réussite financière.
        </p>
      </div>

      <div class="gallery-grid">
        <div 
          class="gallery-item" 
          v-for="(photo, index) in photos" 
          :key="index"
        >
          <img :src="photo.src" :alt="photo.alt">
          <div class="gallery-overlay">
            <h4>{{ photo.title }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GallerySection',
  data() {
    return {
      photos: [
        { src: '/tofs_1.jpg', alt: 'Équipe Oasis Finance 1', title: 'Notre équipe dynamique' },
        { src: '/tofs_2.jpg', alt: 'Équipe Oasis Finance 2', title: 'Professionnalisme' },
        { src: '/tofs_3.jpg', alt: 'Équipe Oasis Finance 3', title: "Esprit d'équipe" },
        { src: '/tofs_5.jpg', alt: 'Équipe Oasis Finance 5', title: 'Engagement' },
        { src: '/tofs_6.jpg', alt: 'Équipe Oasis Finance 6', title: 'À votre service' },
        { src: '/accueil3.jpg', alt: 'Agence Oasis Finance', title: 'Notre agence' }
      ]
    }
  }
}
</script>

<style scoped>
.gallery-section {
  padding: 6rem 2rem;
  background: var(--white);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem;
}

.section-label {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-blue);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: var(--gray-900);
  line-height: 1.2;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--gray-600);
  line-height: 1.7;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.gallery-item {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  aspect-ratio: 4/3;
  cursor: pointer;
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition-slow);
}

.gallery-item::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(10, 44, 94, 0.8) 0%, transparent 60%);
  opacity: 0;
  transition: var(--transition-base);
  z-index: 1;
}

.gallery-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.5rem;
  color: var(--white);
  transform: translateY(100%);
  transition: var(--transition-base);
  z-index: 2;
}

.gallery-overlay h4 {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 600;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

.gallery-item:hover::before {
  opacity: 1;
}

.gallery-item:hover .gallery-overlay {
  transform: translateY(0);
}

@media (max-width: 1024px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .gallery-section {
    padding: 4rem 1.5rem;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }
}
</style>
